export default __webpack_public_path__ + "static/media/victory.f1e7cce8.wav";